export default import.meta.ROLLUP_FILE_URL_w1hMbA7Cg7gYxGqfBM20mA